import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getContentGate, getGatingType } from "@/content-hub/store/selectors";

type PlayerToggleProps = {
  isEditorEnabled: boolean;
  hasPlayableUrl: boolean;
};

export const usePlayerToggle = ({
  isEditorEnabled,
  hasPlayableUrl,
}: PlayerToggleProps) => {
  const [isPlayerOpen, setIsPlayerOpen] = useState(false);
  const { contentGateCompleted } = useSelector(getContentGate);
  const gatingType = useSelector(getGatingType);
  const dispatch = useDispatch();
  const shouldAutoPlay = useRef(false);

  const shouldShowContentGating =
    !contentGateCompleted && gatingType !== "OPEN_ACCESS";

  const openPlayer = useCallback(() => {
    if (isEditorEnabled) return;

    if (shouldShowContentGating) {
      dispatch({
        type: "[content page] show content gate",
      });
      shouldAutoPlay.current = true;
    } else {
      setIsPlayerOpen(true);
    }
  }, [isEditorEnabled, shouldShowContentGating, dispatch]);

  useEffect(() => {
    if (shouldAutoPlay.current && contentGateCompleted && hasPlayableUrl) {
      setIsPlayerOpen(true);
      shouldAutoPlay.current = false;
    }
  }, [contentGateCompleted, dispatch, hasPlayableUrl]);

  return {
    isPlayerOpen,
    openPlayer,
    closePlayer: () => setIsPlayerOpen(false),
  };
};
